import { render, staticRenderFns } from "./WaSideMenuCategoryItem.vue?vue&type=template&id=0553aa50"
import script from "./WaSideMenuCategoryItem.vue?vue&type=script&lang=js"
export * from "./WaSideMenuCategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports